import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { http } from "../lib/http";
import { setToken, setUser } from "../lib/authToken";
import "../styles/signin.css";

export default function SignIn() {
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [otpToken, setOtpToken] = useState("");
  const [isOtpGenerated, setIsOtpGenerated] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [currentImage, setCurrentImage] = useState(0);
  const navigate = useNavigate();

  const images = [
    "https://images.unsplash.com/photo-1551218808-94e220e084d2?auto=format&fit=crop&w=900&q=80",
    "https://images.unsplash.com/photo-1528605248644-14dd04022da1?auto=format&fit=crop&w=900&q=80",
    "https://images.unsplash.com/photo-1504674900247-0877df9cc836?auto=format&fit=crop&w=900&q=80",
    "https://images.unsplash.com/photo-1540189549336-e6e99c3679fe?auto=format&fit=crop&w=900&q=80",
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % images.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [images.length]);
  
  const handleGenerateOtp = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const response = await http.post("/fe/auth/request-otp", { email });
      setOtpToken(response.otp_token);
      setIsOtpGenerated(true);
    } catch (err) {
      setError("Failed to generate OTP. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOtp = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const response = await http.post("/fe/auth/verify-otp", { email, otp, otp_token: otpToken });
      setToken(response.access_token);
      setUser({
        name: response.name,
        email: response.email,
        restaurant_id: response.restaurant_id,
        location: response.location,
        role: response.role || 'staff', // Default to 'staff' if no role provided
        permissions: response.permissions || [],
      });
      navigate("/dashboard");
    } catch (err) {
      setError("Invalid OTP. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="signin-page">
      <button className="back-website" onClick={() => navigate("/")}>
        ← Back to website
      </button>
      <div className="signin-header">
        <h1>Welcome to Mealinkr</h1>
        <p>Bringing great meals closer to you.</p>
      </div>
      <div className="signin-card glass">
        <div className="image-carousel">
          {images.map((img, index) => (
            <div
              key={index}
              className={`carousel-image ${index === currentImage ? "active" : ""}`}
              style={{ backgroundImage: `url(${img})` }}
            ></div>
          ))}
        </div>
        <div className="signin-form">
          <h1 className="signin-title">Mealinkr</h1>
          <h2 className="signin-subtitle">Sign In</h2>
          <p className="signin-text">
            {isOtpGenerated
              ? "Enter the OTP sent to your email"
              : "Welcome back! Enter your email to get OTP"}
          </p>

          {error && <p className="error-message">{error}</p>}

          {!isOtpGenerated ? (
            <form onSubmit={handleGenerateOtp}>
              <input
                type="email"
                placeholder="Email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <button type="submit" className="signin-btn" disabled={loading}>
                {loading ? "Generating..." : "Generate OTP"}
              </button>
            </form>
          ) : (
            <form onSubmit={handleVerifyOtp}>
              <input
                type="text"
                placeholder="Enter OTP"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                required
              />
              <button type="submit" className="signin-btn" disabled={loading}>
                {loading ? "Verifying..." : "Verify OTP"}
              </button>
              <button
                type="button"
                className="back-btn"
                onClick={() => setIsOtpGenerated(false)}
              >
                Back
              </button>
            </form>
          )}

          {/* <p className="signin-footer">
            Need an account? <a href="/signup">Sign up</a>
          </p> */}
        </div>
      </div>
    </div>
  );
}
